import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PortalAccessGuard } from '../../guards/portal-access/portal-access.guard';
import { SessionGuard } from '../../guards/session/session.guard';
import { FreeServicesPortalComponent } from './free-services-portal.component';
import { ValidRequestTypeGuard } from './guards/valid-request-type.guard';
import { NewRequestSummaryComponent } from './new-request-summary/new-request-summary.component';
import { NewRequestComponent } from './new-request/new-request.component';

export enum FreeServicesCaseType {
  Request = 'new-request',
  Agreement = 'new-agreement',
}

export const freeServicesCaseTypeRoutingParam = 'caseType';

const freeServicesPortalRoutes: Routes = [
  {
    path: 'free-services-portal',
    component: FreeServicesPortalComponent,
    canActivate: [SessionGuard, PortalAccessGuard],
    children: [
      {
        path: '',
        redirectTo: 'request-list',
        pathMatch: 'full',
      },
      {
        path: `case-request/:${freeServicesCaseTypeRoutingParam}`,
        canActivate: [ValidRequestTypeGuard],
        component: NewRequestComponent,
      },
      {
        path: `case-agreement/:${freeServicesCaseTypeRoutingParam}`,
        canActivate: [ValidRequestTypeGuard],
        component: NewRequestComponent,
      },
      {
        path: 'new-request-summary',
        component: NewRequestSummaryComponent,
      },
      {
        path: 'request-list',
        loadChildren: () =>
          import('./free-services-map/free-services-map.module').then(
            (m) => m.FreeServicesMapModule,
          ),
      },
      {
        path: '**',
        redirectTo: `case-request/${FreeServicesCaseType.Request}`,
        pathMatch: 'full',
      },
    ],
  },
];
@NgModule({
  imports: [RouterModule.forChild(freeServicesPortalRoutes)],
  providers: [SessionGuard, PortalAccessGuard, ValidRequestTypeGuard],
  exports: [RouterModule],
})
export class FreeServicesPortalRoutingModule {}
